var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{ref:"file",staticClass:"upload-demo",attrs:{"drag":"","size":"mini","action":"","file-list":_vm.fileList,"list-type":"picture","on-change":function(file,fileList){
     _vm.$emit('model-updated', file, _vm.schema.model)
   },"on-remove":function(file,fileList){
     _vm.deleteFile(file,fileList)
   },"multiple":"","auto-upload":false}},[_c('i',{staticClass:"el-icon-upload"}),_c('div',{staticClass:"el-upload__text"},[_vm._v("Cliquez ici pour joindre les fichiers ")]),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("Fichiers jpg/png avec une taille inférieure à 500kb")])])
}
var staticRenderFns = []

export { render, staticRenderFns }